// ========================================================
// Default Configuration
// ========================================================

type Config = {
  AUTHENTICATOR_URL: string;
  MONITORING_URL: string;
  SMART_ALLOCATION_URL: string;
};

const config: Config = {
  AUTHENTICATOR_URL:
    window.appVariables.AUTHENTICATOR_URL ?? 'https://api.staging.bnpparibas-am.com/authenticator',
  MONITORING_URL:
    window.appVariables.MONITORING_URL ??
    'https://canary-api.bnpparibas-am.staging.echonet/monitoring',
  SMART_ALLOCATION_URL:
    window.appVariables.SMART_ALLOCATION_URL ??
    'https://smart-allocation.am.staging.echonet/smart-allocation',
};

export default config;
